import React, { useEffect, useState } from 'react'
import HttpClient from '../../utils/HttpClient';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import nophoto from '../../Images/nophoto.jpg'
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import { Autocomplete, TextField, Chip } from "@mui/material";

const PostEdit = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const data = location?.state

    const initdata = {
        subject: data?.subject,
        description: data?.description,
        file: data?.file,
        searchKeywordsId: data?.searchKeywordsId,
        searchKeywords: data?.searchKeywords,
        targetAudience: data?.targetAudience,
        targetAudienceId: data?.targetAudienceId,
    };
    const [PostData, setPostData] = useState(initdata);
    const [isUploadingBusinesBanner, setIsUploadingBusinesBanner] = useState(false)

    useEffect(() => {
        getCompanyTypes()
        getBusinessKeywords()
    }, []);

    //handlechange
    const handleChange = (e) => {
        const { name, value } = e.target;

        setPostData((prev) => ({ ...prev, [name]: value }));
    };


    // handle sublit 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const dataEdit = {
            ...PostData,
            targetAudience: selectedOptions.map((item) => item.label),
            targetAudienceId: selectedOptions.map((item) => item.value),
            searchKeywords: selectedKeywordOptions.map((item) => item.keyword),
            searchKeywordsId: selectedKeywordOptions.map((item) => item._id),
        };

        // return

        const res = await HttpClient.requestData("update-business-post/" + data._id, "PUT", dataEdit)
        if (res && res?.status) {
            toast.success("Updated Succesfully")
            navigate("/posts")
        }
        else {
            toast.error(res?.msg)
        }

    }

    //
    const handleCancel = (e) => {
        e.preventDefault()
        navigate("/posts")
    }

    // select the Image
    const handleUpload = async (e) => {
        const { name, files } = e.target;
        setIsUploadingBusinesBanner(true)
        if (files && files.length > 0) {
            // File is selected, perform image upload
            const formData = new FormData();
            formData.append("image", files[0]);
            const res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                // Update state with the URL of the uploaded image

                setPostData(prev => ({
                    ...prev,
                    [name]: res?.data?.url
                }));
                setIsUploadingBusinesBanner(false)
            }
        }
    };

    //Target Audience Multi Select

    const [serviceOptions, setServiceOptions] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([]);

    const getCompanyTypes = async () => {
        try {
            const res = await HttpClient.requestData(
                "view-companyType",
                "GET",
                {}
            );

            if (res?.status) {

                const filteredData = res.data.filter(
                    (item) => !selectedOptions.includes(item.value)
                );

                setServiceOptions(filteredData.map((item) => ({
                    value: item._id,
                    label: item.type,
                })) || []);

                /////
                const presentServiceData = res.data.filter(
                    (item) => PostData.targetAudienceId.includes(item._id)
                );

                setSelectedOptions(presentServiceData.map((item) => ({
                    value: item._id,
                    label: item.type,
                })) || []);
            }
        } catch (error) {
            console.error("Error occured!", error);
        }
    };

    const handleServiceChange = (selected) => {
        setSelectedOptions(selected);
    };

    ////Keywords////

    //selectedKeywordOptions
    const [keywordOptions, setKeywordOptions] = useState([])
    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState([])

    const getBusinessKeywords = async () => {
        try {
            const res = await HttpClient.requestData(
                "business-product-keyword",
                "GET"
            );

            if (res?.status) {
                const filteredData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductkeywords.includes(item._id)
                    (item) => !selectedKeywordOptions.includes(item._id)
                );
                setKeywordOptions(filteredData || [])

                /////
                const presentKeywordData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductCat.includes(item._id)
                    (item) => PostData.searchKeywordsId.includes(item._id)
                );
                setSelectedKeywordOptions(presentKeywordData || []);
            }
        } catch (error) {
            console.error("Error fetching country states:", error);
        }
    }

    const handleKeywordsChange = (event, newValue) => {
        setSelectedKeywordOptions(newValue);
    };

    const upgradeToRequestedPlan = (e) => {
        e.preventDefault()
        setPostData((prev) => ({ ...prev, subscriptionId: e.target.id }));
    }

    return (
        <>
            <div className="d-flex justify-content-end">
                <div className="form-header">


                    <section className="piechartsBox_area bg-light">
                        <div className="container">
                            <div className="row justify-content-md-center">
                                <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                                    <h3 className="fs-6 text-secondary mb-2 text-uppercase text-center">
                                        Update Post
                                    </h3>

                                    <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="row gy-3 gy-md-4 gy-lg-0 justify-content-md-center">

                                <div className="col-12 col-lg-12">
                                    <div className="row justify-content-xl-center">
                                        <div className="col-12 col-xl-11">
                                            <div className="bg-white border rounded shadow-sm overflow-hidden">
                                                <form action="#!">
                                                    <div className="row gy-4 gy-xl-5 p-4 p-xl-5">
                                                        {/* Subject */}
                                                        <div className="col-12">
                                                            <label htmlFor="fullname" className="form-label">
                                                                Subject <span className="text-danger">*</span>
                                                            </label>
                                                            <input

                                                                className="form-control"
                                                                type="text"
                                                                name="subject"
                                                                value={PostData.subject}
                                                                placeholder="Enter a meaningful subject line"
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        {/* Description */}
                                                        <div className="col-12 col-md-12 my-3">
                                                            <label htmlFor="description" className="form-label">
                                                                Description <span className="text-danger">*</span>
                                                            </label>
                                                            <div className="input-group">
                                                                <textarea className="form-control" name="description" rows="4" onChange={handleChange} placeholder="Enter the description...">{PostData?.description || ""}</textarea>
                                                            </div>
                                                        </div>

                                                        {/* Target Audience */}
                                                        <div className="col-12 col-md-12 my-3"
                                                            style={{ zIndex: "10" }}
                                                        >
                                                            <label htmlFor="services" className="form-label">
                                                                Target Audience
                                                            </label>
                                                            <Select
                                                                options={serviceOptions}
                                                                isMulti
                                                                value={selectedOptions}
                                                                onChange={handleServiceChange}
                                                                placeholder="Target audiences..."
                                                            />
                                                        </div>

                                                        {/* Keywords */}
                                                        <div className="col-12 col-md-12 my-3">
                                                            <label htmlFor="keywords" className="form-label">
                                                                Keywords
                                                            </label>
                                                            <Autocomplete
                                                                multiple
                                                                options={keywordOptions}
                                                                getOptionLabel={(option) => option.keyword}
                                                                value={selectedKeywordOptions}
                                                                onChange={handleKeywordsChange}
                                                                isOptionEqualToValue={(option, value) => option._id === value._id}
                                                                renderTags={(value, getTagProps) =>
                                                                    value.map((option, index) => (
                                                                        <Chip
                                                                            key={option.id}
                                                                            label={option.keyword}
                                                                            {...getTagProps({ index })}
                                                                        />
                                                                    ))
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField {...params} label="Select keywords" placeholder="Type to search" />
                                                                )}
                                                            />
                                                        </div>

                                                        {/* File */}
                                                        <div className="col-12">
                                                            <label htmlFor="banner" className="form-label" style={{ display: "block" }}>
                                                                Attachment
                                                            </label>
                                                            {
                                                                isUploadingBusinesBanner ?
                                                                    <Oval
                                                                        height={80}
                                                                        width={80}
                                                                        color="#4fa94d"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass=""
                                                                        visible={true}
                                                                        ariaLabel='oval-loading'
                                                                        secondaryColor="#4fa94d"
                                                                        strokeWidth={2}
                                                                        strokeWidthSecondary={2}
                                                                    /> :
                                                                    <img
                                                                        src={PostData.file || nophoto}
                                                                        style={{ maxWidth: "100%", borderRadius: "8px", maxHeight: "256px", padding: "5px 0" }}
                                                                    />
                                                            }
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                name="file"
                                                                // value={PostData.companyName}
                                                                onChange={(e) => handleUpload(e)}
                                                            />
                                                        </div>

                                                        <div className="col-12 mt-3">
                                                            <div className="d-flex justify-content-end">
                                                                <button className="btn btn-primary btn-sm" type="submit" onClick={(e) => handleSubmit(e)}>
                                                                    Save Changes
                                                                </button>
                                                                <button className="btn btn-danger btn-sm" type="submit" onClick={(e) => handleCancel(e)}>
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

            </div>





        </>
    )
}

export default PostEdit